import styled from "styled-components";

export const ModalContent = styled.div`
  p {
    font-weight: 300;
  }
`;